// Page and limit come from the query string: anything that is not a positive integer
// (0, -1, "abc"...) is rejected by the API, so fall back to a sane default.
export function toPositiveIntString(value, fallback) {
  const parsed = parseInt(value, 10)

  return (Number.isInteger(parsed) && parsed > 0 ? parsed : fallback).toString()
}
